export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70983e21483879f481fa3d9ab9a6dac6b10d57508e&name=pushAdClickData!'